package map

import apiclient.geoobjects.ObjectType
import auth.ApiUserStore
import data.users.ActiveUserStore
import dev.fritz2.core.RootStore
import dev.fritz2.core.SimpleHandler
import koin.koinCtx
import koin.withKoin
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.combine
import location.GeoPositionStore
import location.LocationFollowStore
import location.LocationUploadStore
import location.geolocation.GeoPosition
import maplibreGL.FormationMap
import maplibreGL.LngLat
import maplibreGL.MaplibreMarkerOptions
import maplibreGL.Marker
import maplibreGL.generateMyMaplibreUserMarker
import maplibreGL.toJs
import mapsearch.MarkerGenerators.makeSvgMarkerForMap
import mapsearch.userMarkerEventListener
import model.User
import svgmarker.MarkerSize


class MyUserMarkerStore : RootStore<Marker?>(
    initialData = null,
    job = Job(),
) {

    private val geoPositionStore: GeoPositionStore by koinCtx.inject()
    private val locationUploadStore: LocationUploadStore by koinCtx.inject()
    private val locationFollowStore: LocationFollowStore by koinCtx.inject()
    private val apiUserStore: ApiUserStore by koinCtx.inject()
    private val activeUserStore: ActiveUserStore by koinCtx.inject()

    val initialize = handle { current -> current }

    private val updateMyUserPosition = SimpleHandler<Pair<User, GeoPosition?>> { data, _ ->
        data handledBy { (user, position) ->
            withKoin {
                val formationMap: FormationMap = get()
                val map = formationMap.map
                position?.let { geoPosition ->
                    val userFeature = generateMyMaplibreUserMarker(
                        user = user,
                        position = geoPosition,
                    )
                    current?.setLngLat(
                        LngLat(
                            geoPosition.coords.longitude,
                            geoPosition.coords.latitude,
                        ),
                    ) ?: run {
                        val markerOptions = MaplibreMarkerOptions(
                            element = makeSvgMarkerForMap(
                                id = userFeature.id,
                                title = userFeature.title,
                                svgIconOptions = userFeature.svgIconOptions.copy(size = MarkerSize.S),
                                objectType = ObjectType.Building,
                                active = userFeature.isActive,
                                showTitle = userFeature.showTitle,
                            ).also { element ->
                                if (!userFeature.svgIconOptions.desaturated) { // make non-clickable when desaturated (= disabled)
                                    element.addEventListener("click", userMarkerEventListener)
                                }
                            },
                        )
                        val newMarker = Marker(markerOptions.toJs())
                        newMarker.setLngLat(LngLat(geoPosition.coords.longitude, geoPosition.coords.latitude))
                        newMarker.addTo(map)
                        update(newMarker)
                    }
                }
            }
        }
    }

    init {
        combine(
            apiUserStore.data,
            activeUserStore.data,
            locationUploadStore.data,
            locationFollowStore.data,
            geoPositionStore.data,
        ) { user, _, _, _, position -> Pair(user, position) } handledBy updateMyUserPosition
    }
}
